(() => {
  const widget = document.querySelector('[data-product-kit-progress]');
  if (!widget) return;
  const builderUrl = document.querySelector('[data-global-kit]')?.dataset.builderUrl || widget.dataset.builderUrl;
  const root = window.MudjugConfig?.root || '/';
  const count = widget.querySelector('[data-product-kit-count]');
  const fill = widget.querySelector('[data-product-kit-fill]');
  const steps = widget.querySelector('[data-product-kit-steps]');
  const message = widget.querySelector('[data-product-kit-message]');
  const track = widget.querySelector('[data-product-kit-track]');
  const link = widget.querySelector('.mj-product-kit__link');
  if (builderUrl) link.href = builderUrl;
  let config = null;
  let cart = null;
  const nextRewardMessage = (tiers, count) => {
    const rewards = tiers.filter(t => /\$\s*\d+|free.*lid/i.test(`${t.label} ${t.description}`));
    const next = rewards.find(t => count < t.threshold);
    if (!next) return 'All field kit milestones unlocked!';
    const combined = `${next.label} ${next.description}`;
    const name = /free.*lid/i.test(combined) ? 'your FREE Dip Can Lid' : ((combined.match(/\$\s*[\d,.]+/)||[''])[0].replace(/\s+/g,'') + ' off' + (/free shipping/i.test(combined)?' + free shipping':''));
    const remaining = next.threshold-count;
    return `Add ${remaining} more Mudjug${remaining===1?'':'s'} to unlock ${name}`;
  };
const getCollectionEligible = async (builder) => {
    const handle = builder?.dataset.eligibleCollection;
    if (!handle || handle === 'all') return new Set();
    const ids = new Set([...builder.querySelectorAll('[data-bundle-product]')].map(node => String(node.dataset.productId)).filter(Boolean));
    for (let page = 1; page <= 100; page++) {
      const res = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
      if (!res.ok) { if (ids.size) return ids; throw new Error('Unable to load eligible Mudjug collection'); }
      const products = (await res.json()).products || [];
      products.forEach(p => ids.add(String(p.id)));
      if (products.length < 250) return ids;
    }
    return ids;
  };
  function eligibleQuantity() {
    if (!cart) return 0;
    return (cart.items || []).filter(item => {
      const props = item.properties || {};
      if (Object.keys(props).some(k => k.toLowerCase().includes('mudjug_reward_candidate'))) return false;
      return (config?.eligible?.has(String(item.product_id)) ?? false);
    }).reduce((sum, item) => sum + item.quantity, 0);
  }
  function render() {
    if (!cart) return;
    const qty = eligibleQuantity();
    count.textContent = `${qty} ${qty === 1 ? 'MUDJUG' : 'MUDJUGS'}`;
    if (!config?.tiers?.length) {
      message.textContent = 'Visit the field kit builder to see available milestones.';
      fill.style.width = '0%';
      steps.replaceChildren();
      return;
    }
    const tiers = config.tiers;
    const next = tiers.find(t => qty < t.threshold);
    const max = tiers[tiers.length - 1].threshold;
    fill.style.width = `${Math.max(0,Math.min(100,qty/max*100))}%`;
    track.setAttribute('aria-valuemax',String(max));
    track.setAttribute('aria-valuenow',String(Math.min(qty,max)));
    steps.replaceChildren();
    tiers.forEach(t => {
      const node = document.createElement('div');
      node.className = 'mj-product-kit__step' + (qty >= t.threshold ? ' is-done' : next === t ? ' is-next' : '');
      const number = document.createElement('span');
      number.className = 'mj-product-kit__step-number';
      number.textContent = qty >= t.threshold ? '✓' : String(t.threshold);
      const name = document.createElement('span');
      name.className = 'mj-product-kit__step-title';
      name.textContent = `${t.threshold} ${t.threshold === 1 ? 'MudJug' : 'MudJugs'}`;
      const reward = document.createElement('span');
      reward.className = 'mj-product-kit__step-reward';
      reward.textContent = t.description || t.label;
      node.append(number,name,reward);
      node.title = `${t.label}: ${t.description || ''}`;
      steps.append(node);
    });
    if (next) {
      const remaining = next.threshold - qty;
      message.textContent = nextRewardMessage(tiers, qty);
    } else {
      message.textContent = nextRewardMessage(tiers, qty);
    }
  }
  async function loadCart() {
    try {
      const r = await fetch(`${root}cart.js`,{credentials:'same-origin'});
      if (r.ok) {cart=await r.json();render();}
    } catch (_) {}
  }
  async function loadConfig() {
    try {
      const r=await fetch(builderUrl,{credentials:'same-origin',headers:{Accept:'text/html'}});
      if (!r.ok) throw Error('Builder unavailable');
      const doc=new DOMParser().parseFromString(await r.text(),'text/html');
      const builder=doc.querySelector('[data-bundle-builder]');
      if (!builder) throw Error('Builder not found');
      const tiers=[...builder.querySelectorAll('[data-bundle-milestone]')].map(n=>({
        threshold:Number(n.dataset.threshold),
        label:n.querySelector('.bundle-milestone__copy strong')?.textContent?.trim() || 'Milestone',
        description:n.querySelector('.bundle-milestone__copy > span')?.textContent?.trim() || ''
      })).filter(t=>Number.isFinite(t.threshold)&&t.threshold>0).sort((a,b)=>a.threshold-b.threshold);
      const eligible=await getCollectionEligible(builder);
      config={tiers,eligible};
      // Fail closed: only show the milestone panel on products in the
      // configured spittoons-only collection. Other products never flash it.
      const eligibleProduct = eligible.has(String(widget.dataset.productId));
      widget.hidden = !eligibleProduct;
      widget.style.display = eligibleProduct ? '' : 'none';
      if (eligibleProduct) render();
    } catch (_) {message.textContent='View your field kit to see available milestones.';}
  }
  document.addEventListener('mudjug:cart-updated',e=>{if(e.detail?.items){cart=e.detail;render();}else loadCart();});
  document.addEventListener('cart:updated', loadCart);
  document.addEventListener('cart:refresh', loadCart);
  window.addEventListener('pageshow',loadCart);
  document.addEventListener('shopify:section:load',()=>{loadConfig();loadCart();});
  loadConfig();loadCart();
})();
